<template>
    <div>
        <vx-card title="" no-shadow card-border id="" class="mt-base">
            <div class="flex items-end">
                <feather-icon icon="PackageIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Proyecto de Inversión</span>
            </div>

            <vs-divider/>

            <div class="w-full mt-2 vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button 
                        ref="loadableButton" 
                        id="button-uppdate-with-loading" 
                        class="mt-2 ml-auto vs-con-loading__container"
                        @click="actualizar" 
                        icon-pack="feather" 
                        color="rgb(62, 201, 214)" 
                        icon="icon-refresh-ccw">
                        Actualizar
                    </vs-button>                  
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">CODIGO UNICO</label>
                    <div class="w-full mb-2 vx-col md:w-1/2">
                        <vs-input class="w-full font-bold text-primary" readonly v-model="inputCUI" v-validate="'required|numeric'" name="codigo" placeholder="Codigo único o SNIP"/>
                        <span class="text-sm text-danger" v-show="errors.has('codigo')">{{ errors.first('codigo') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full vx-col">
                <label class="ml-2 text-sm opacity-100">Nombre de la Inversión</label>
                <div class="w-full vx-col">
                    <vs-textarea class="w-full" v-model="inputNombreInversion" v-validate="'required'" name="nombre" placeholder="Ingrese nombre de la Inversión"/>
                    <span class="text-sm text-danger" v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Costo del Proyecto</label>
                    <vs-input class="w-full" v-model="inputCostoProyecto" v-validate="'required'" name="costo" placeholder="Ingrese el costo del proyecto"/>
                    <span class="text-sm text-danger" v-show="errors.has('costo')">{{ errors.first('costo') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Monto Viable</label>
                    <vs-input class="w-full" v-model="inputMontoViable" v-validate="'required'" name="monto" placeholder="Ingrese monto viable"/>
                    <span class="text-sm text-danger" v-show="errors.has('monto')">{{ errors.first('monto') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Longitud</label>
                    <vs-input class="w-full" v-model="inputLongitud" v-validate="'required'" name="longitud" placeholder="Ingrese longitud"/>
                    <span class="text-sm text-danger" v-show="errors.has('longitud')">{{ errors.first('longitud') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Latitud</label>
                    <vs-input class="w-full" v-model="inputLatitud" v-validate="'required'" name="codigo" placeholder="Ingrese latitud"/>
                    <span class="text-sm text-danger" v-show="errors.has('latitud')">{{ errors.first('codigo') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Estado situacional</label>
                    <vs-input class="w-full" v-model="inputEstadoSituacional" v-validate="'required'" name="estado" placeholder="Estado situacional"/>
                    <span class="text-sm text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">PIM Vigente</label>
                    <vs-input class="w-full" v-model="inputPimVigente" v-validate="'required'" name="pim" placeholder="Ingrese PIM vigente"/>
                    <span class="text-sm text-danger" v-show="errors.has('pim')">{{ errors.first('pim') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Devengado acumulado</label>
                    <vs-input class="w-full" v-model="inputDevAcumulado" v-validate="'required'" name="dev-acumulado" placeholder="Ingrese devengado acumulado"/>
                    <span class="text-sm text-danger" v-show="errors.has('dev-acumulado')">{{ errors.first('dev-acumulado') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Devengado Vigente</label>
                    <vs-input class="w-full" v-model="inputDevVigente" v-validate="'required'" name="dev-vigente" placeholder="Ingrese devengado vigente"/>
                    <span class="text-sm text-danger" v-show="errors.has('dev-vigente')">{{ errors.first('dev-vigente') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Departamento</label>
                    <vs-input class="w-full" v-model="inputDepartamento" v-validate="'required'" name="departamento" placeholder="Ingrese el Departamento"/>
                    <span class="text-sm text-danger" v-show="errors.has('departamento')">{{ errors.first('departamento') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Provincia</label>
                    <vs-input class="w-full" v-model="inputProvincia" v-validate="'required'" name="provincia" placeholder="Ingrese la Provincia"/>
                    <span class="text-sm text-danger" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Distrito</label>
                    <vs-input class="w-full" v-model="inputDistrito" v-validate="'required'" name="distrito" placeholder="Ingrese el Distrito"/>
                    <span class="text-sm text-danger" v-show="errors.has('distrito')">{{ errors.first('distrito') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Fecha de Inicio</label>
                    <vs-input class="w-full" v-model="inputFechaInicio" v-validate="'required'" name="fecha-inicio" placeholder="Ingrese Fecha de inicio de ejecución"/>
                    <span class="text-sm text-danger" v-show="errors.has('fecha-inicio')">{{ errors.first('fecha-inicio') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Fecha Fin</label>
                    <vs-input class="w-full" v-model="inputFechaFin" v-validate="'required'" name="fecha-fin" placeholder="Ingrese Fecha de Culminación"/>
                    <span class="text-sm text-danger" v-show="errors.has('fecha-fin')">{{ errors.first('fecha-fin') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Fecha Declaración</label>
                    <vs-input class="w-full" v-model="inputfechaDeclaracion" v-validate="'required'" name="fecha-declaracion" placeholder="Ingrese Fecha de Declaración"/>
                    <span class="text-sm text-danger" v-show="errors.has('fecha-declaracion')">{{ errors.first('fecha-declaracion') }}</span>
                </div>
            </div>

            <div class="w-full vx-col">
                <label class="ml-2 text-sm opacity-100">Situación</label>
                <div class="w-full vx-col">
                    <vs-textarea class="w-full" v-model="inputSituacion" v-validate="'required'" name="situacion" placeholder="Ingreso la situacion actual del proyecto"/>
                    <span class="text-sm text-danger" v-show="errors.has('situacion')">{{ errors.first('situacion') }}</span>
                </div>
            </div>

            <div class="w-full mt-2 vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button @click="regresar" icon-pack="feather" color="success" icon="icon-rotate-ccw" class="mt-2 ml-auto">Regresar</vs-button>
                    <vs-button @click="limpiar" icon-pack="feather" color="danger" type="border" icon="icon-trash"  class="mt-2 ml-4">Limpiar</vs-button>
                </div>
            </div>

        </vx-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            parametro               : null,

            inputCUI                : null,
            inputNombreInversion    : null,
            inputCostoProyecto      : null,
            inputMontoViable        : null,
            inputLongitud           : null,
            inputLatitud            : null,
            inputEstadoSituacional  : null,
            inputPimVigente         : null,
            inputDevAcumulado       : null,
            inputDevVigente         : null,
            inputDepartamento       : null,
            inputProvincia          : null,
            inputDistrito           : null,
            inputFechaInicio        : null,
            inputFechaFin           : null,
            inputfechaDeclaracion   : null,
            inputSituacion          : null,

            backgroundLoading       :'primary',
            colorLoading            :'#fff',
        }
    },

    created(){
        this.parametro = this.$route.params.id;
    },

    mounted(){
        this.getProyecto(this.parametro);
    },

    methods: {

        loadData(data){
            this.inputCUI               = data.cui;
            this.inputNombreInversion   = data.nombreInversion;
            this.inputCostoProyecto     = data.montoActualizado;
            this.inputMontoViable       = data.montoViable;
            this.inputLongitud          = data.x;
            this.inputLatitud           = data.y;
            this.inputEstadoSituacional = data.estadoSituacional;
            this.inputPimVigente        = data.pimVigente;
            this.inputDevAcumulado      = data.devengadoAcumulado;
            this.inputDevVigente        = data.devengadoVigente;
            this.inputDepartamento      = data.departamento;
            this.inputProvincia         = data.provincia;
            this.inputDistrito          = data.distrito;
            this.inputFechaInicio       = data.fechaInicioEjec;
            this.inputFechaFin          = data.fechaFinEjec;
            this.inputfechaDeclaracion  = data.fechaDeclaracion;
            this.inputSituacion         = data.situacion;
        },

        getProyecto(value){
            this.$vs.loading();
            this.$http.findProyectoById(value)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.loadData(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        guardar(){},

        limpiar(){
            this.inputNombreInversion    = null;
            this.inputCostoProyecto      = null;
            this.inputMontoViable        = null;
            this.inputLongitud           = null;
            this.inputLatitud            = null;
            this.inputEstadoSituacional  = null;
            this.inputPimVigente         = null;
            this.inputDevAcumulado       = null;
            this.inputDevVigente         = null;
            this.inputDepartamento       = null;
            this.inputProvincia          = null;
            this.inputDistrito           = null;
            this.inputFechaInicio        = null;
            this.inputFechaFin           = null;
            this.inputfechaDeclaracion   = null;
            this.inputSituacion          = null;
        },

        actualizar(){
            this.$vs.loading({
                background: 'rgb(62, 201, 214)',
                color: this.colorLoading,
                container: "#button-uppdate-with-loading",
                scale: 0.45
            });

            this.$http.updateFromSSI(this.inputCUI)
            .then(response => {
                this.$vs.loading.close("#button-uppdate-with-loading > .con-vs-loading")
                if(response.status === 200){
                    this.loadData(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close("#button-uppdate-with-loading > .con-vs-loading")
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        regresar(){
            this.$router.push({
				name: 'app-parametro-proyecto'
			}).catch(() => {});
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>